import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/auth/Login";
import Health from "./pages/health/Health";
import PrivateRoute from "./pages/auth/PrivateRoute";
import Layout from "./shared/components/layout/Layout";
import Organizations from "./pages/organizations/Organizations";
import Users from "./pages/users/Users";

export const AppRoutes = ({
  isAuthenticated,
}: {
  isAuthenticated: boolean;
}) => {
  const location = useLocation();
  console.log("Current route:", location.pathname, "Auth status:", isAuthenticated);
  
  return (
    <Routes>
      <Route
        path="/login"
        element={
          !isAuthenticated ? <Login /> : <Navigate to="/organizations" replace state={{ from: location }} />
        }
      />
      <Route path="/health" element={<Health />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export const LayoutRoutes = () => {
  const location = useLocation();
  
  return (
    <Routes>
      <Route path="/organizations" element={<Organizations />} />
      <Route path="/users" element={<Users />} />
      <Route path="*" element={
        location.pathname !== "/organizations" ? 
        <Navigate to="/organizations" replace /> : 
        <Organizations />
      } />
    </Routes>
  );
};
